import PropTypes from "prop-types";

export default PropTypes.arrayOf(
  PropTypes.shape({
    tabSelected: PropTypes.string,
    pipeline: PropTypes.bool,
    timeToHire: PropTypes.bool,
    offerToPlacement: PropTypes.bool,
    spendPerSector: PropTypes.bool,
    totalJobsPosted: PropTypes.bool,
    totalJobsPerSector: PropTypes.bool,
    timeToHireTimeline: PropTypes.bool,
    applicationActionsTracking: PropTypes.bool,
    placementSummary: PropTypes.bool,
    leagueTable: PropTypes.bool,
    fillRate: PropTypes.bool,
  })
);
